module.exports = __webpack_public_path__ + "static/media/back_login2.b5f61c8e.jpg";